var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHospitalUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#264FAE",
    d: "M27.5,21.25 C27.5,17.796875 30.296875,15 33.75,15 C37.203125,15 40,17.796875 40,21.25 C40,24.703125 37.203125,27.5 33.75,27.5 C30.296875,27.5 27.5,24.703125 27.5,21.25 Z M37.7265625,30 C41.7421875,30 45,33.2578125 45,37.2734375 C45,38.78125 43.78125,40 42.2734375,40 L25.2265625,40 C23.71875,40 22.5,38.78125 22.5,37.2734375 C22.5,33.2578125 25.7578125,30 29.7734375,30 L37.7265625,30 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13161E",
    d: "M0,3.75 C0,1.67890625 1.67890625,0 3.75,0 L21.25,0 C23.3203125,0 25,1.67890625 25,3.75 L25,28.734375 C22.015625,30.40625 20,33.59375 20,37.2578125 C20,38.265625 20.28125,39.203125 20.7734375,40 L3.75,40 C1.67890625,40 0,38.3203125 0,36.25 L0,30 L11.25,30 C11.9375,30 12.5,29.4375 12.5,28.75 C12.5,28.0625 11.9375,27.5 11.25,27.5 L0,27.5 L0,22.5 L11.25,22.5 C11.9375,22.5 12.5,21.9375 12.5,21.25 C12.5,20.5625 11.9375,20 11.25,20 L0,20 L0,3.75 Z M10.625,8.125 L8.75,8.125 C8.0625,8.125 7.5,8.6875 7.5,9.375 L7.5,10.625 C7.5,11.3125 8.0625,11.875 8.75,11.875 L10.625,11.875 L10.625,13.75 C10.625,14.4375 11.1875,15 11.875,15 L13.125,15 C13.8125,15 14.375,14.4375 14.375,13.75 L14.375,11.875 L16.25,11.875 C16.9375,11.875 17.5,11.3125 17.5,10.625 L17.5,9.375 C17.5,8.6875 16.9375,8.125 16.25,8.125 L14.375,8.125 L14.375,6.25 C14.375,5.559375 13.8125,5 13.125,5 L11.875,5 C11.1875,5 10.625,5.559375 10.625,6.25 L10.625,8.125 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHospitalUser);
export default __webpack_public_path__ + "static/media/Icon-hospital-user.bb71bec0.svg";
export { ForwardRef as ReactComponent };